<template>
  <div class="q-ma-sm q-gutter-y-sm">
    <div class="q-pa-md bg-white rounded-borders">
      <div class="row q-gutter-md items-start wrap">
        <q-input
          v-model="impressoraNomeRede"
          label="Impressora Nome de Rede"
          square
          class="col-6 q-mb-md"
        ></q-input>

        <q-select
          v-model="impressoraModelo"
          label="Impressora Modelo"
          :options="modelosImpressoras"
          square
          class="col-6 q-mb-md"
          :loading="carregandoModelos"
          behavior="menu"
          emit-value
          map-options
        ></q-select>

        <q-input
          v-model="impressoraNomeComputador"
          label="Nome Computador"
          square
          class="col-6 q-mb-md"
        ></q-input>

        <q-btn
          color="primary"
          label="Buscar Hostname"
          @click="buscarConfiguracao"
        ></q-btn>

        <q-input
          v-model="ipServerImpressao"
          label="Hostname Servidor Impressora"
          square
          class="col-6 q-mb-md"
        ></q-input>

        <q-input
          v-model="configId"
          style="display: none;"
        ></q-input>
      </div>

      <div class="row justify-end q-mt-md">
        <q-btn
          color="primary"
          label="Salvar Configuração"
          @click="salvarConfiguracao"
        ></q-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useQuasar } from 'quasar';
import ParametrosServices from '@/services/parametros';
import ImpressaoServices from '@/services/driver_impressao';

export default {
  name: "ConfiguracaoImpressora",
  setup() {
    const $q = useQuasar();
    const impressoraNomeRede = ref('');
    const impressoraModelo = ref('');
    const modelosImpressoras = ref([]);
    const carregandoModelos = ref(false);
    const configId = ref(null);
    const impressoraNomeComputador = ref('');
    const ipServerImpressao = ref('');

    onMounted(() => {
      carregarModelosImpressoras();
      carregarConfiguracaoLoja();
    });

    const carregarModelosImpressoras = async () => {
      try {
        carregandoModelos.value = true;
        const modelos = await ParametrosServices.listarModelosImpressoras();
        modelosImpressoras.value = modelos.map(modelo => ({
          label: modelo.modelo,
          value: modelo.id
        }));
      } catch (error) {
        console.error("Erro ao carregar modelos de impressoras", error);
        $q.notify({
          message: "Erro ao carregar modelos de impressoras",
          color: "negative",
          position: "top",
          timeout: 3000
        });
      } finally {
        carregandoModelos.value = false;
      }
    };

    const carregarConfiguracaoLoja = async () => {
      try {
        let hostname = await ImpressaoServices.buscarHostname();
        const configuracao = await ParametrosServices.listarConfiguracaoLoja(hostname["nome_computador"]);
        if (configuracao == -1){
          console.log("loja n selecionada")
        }
        else {
          if (configuracao.length > 0) {
            const config = configuracao[0];
            impressoraNomeRede.value = config.nome_impressora || '';
            impressoraModelo.value = config.id_impressora || '';
            impressoraNomeComputador.value = config.nome_computador || ''; 
            ipServerImpressao.value = config.ip_server_impressao || '';
            configId.value = config.id || null;
          }
        }
      } catch (error) {
        $q.notify({
          message: "Não foi possível carregar as configurações. Realize o cadastro.",
          color: "negative",
          position: "top",
          timeout: 3000
        });
      }
    };

    const buscarConfiguracao = async () => {
      try {
        
        const hostname = await ImpressaoServices.buscarHostname();
        impressoraNomeComputador.value = hostname.nome_computador || ''

      } catch (error) {
        console.error("Erro ao carregar configuração!", error);
        $q.notify({
          message: "Erro ao carregar configuração!",
          color: "negative",
          position: "top",
          timeout: 3000
        });
      }
    }

    const salvarConfiguracao = async () => {
      try {
        
        let campo_erro = "";

        if (impressoraNomeRede.value == "" || impressoraNomeRede.value == undefined){
          campo_erro = "Impressora Nome de Rede"
        }
        
        else if (impressoraModelo.value == "" || impressoraModelo.value == undefined){
          campo_erro = "Impressora Modelo"
        }
        else if (impressoraNomeComputador.value == "" || impressoraNomeComputador.value == undefined){
          campo_erro = "Nome Computador"
        }
        else if (ipServerImpressao.value == "" || ipServerImpressao.value == undefined){
          campo_erro = "Hostname Servidor Impressora"
        }

        if (campo_erro != ""){
          $q.notify({
              message: "O campo "+campo_erro+" é obrigatório!",
              color: "negative",
              position: "top",
              timeout: 3000
          });
          return;
        }

        const dadosSalvar = {
          nome_impressora: impressoraNomeRede.value,
          id_impressora: impressoraModelo.value,
          nome_computador: impressoraNomeComputador.value,
          ip_server_impressao: ipServerImpressao.value,
          id: configId.value
        };
        await ParametrosServices.gravarConfiguracaoLoja(dadosSalvar);
        $q.notify({
          message: "Configuração salva com sucesso",
          color: "positive",
          position: "top",
          timeout: 3000
        });
      } catch (error) {
        console.error("Erro ao salvar configuração:", error);
        $q.notify({
          message: "Erro ao salvar configuração",
          color: "negative",
          position: "top",
          timeout: 3000
        });
      }
    };

    return {
      impressoraNomeRede,
      impressoraModelo,
      modelosImpressoras,
      carregandoModelos,
      impressoraNomeComputador,
      ipServerImpressao,
      configId,
      salvarConfiguracao,
      buscarConfiguracao
    };
  }
};
</script>

<style>
.bg-white {
  background-color: white;
}

.rounded-borders {
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>
